module.exports = __webpack_public_path__ + "img/yogurt_amazake.9856e775.jpg";